var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Link } from '@a0/quantum-product';
import { NavLink as FluxibleNavLink } from 'fluxible-router';
import * as React from 'react';
export var NavLink = function (props) {
    return React.createElement(Link, __assign({ component: FluxibleNavLink }, props));
};
